export const $LocalesModuleName = "locales";

export type TLocalesState = {
    current?: string;
    locales: Array<Locale>;
};

export type Locale = {
    path: string;
    language: string;
    languageCode: string;
    languageTag: string;
};
